import { ArrowRight, Target, Users, Award, Lightbulb } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";

const Sobre = () => {
  const values = [
    {
      icon: Target,
      title: "Missão",
      description: "Transformar desafios tecnológicos em soluções inovadoras que impulsionam o crescimento dos nossos clientes."
    },
    {
      icon: Lightbulb,
      title: "Visão",
      description: "Ser referência em desenvolvimento de software e automação, reconhecida pela excelência e inovação."
    },
    {
      icon: Award,
      title: "Valores",
      description: "Compromisso, inovação, transparência e foco total na satisfação do cliente."
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b border-border/50 bg-card/30 backdrop-blur-xl sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/">
            <img src="/logo.png" alt="Coddar Logo" className="h-11 w-auto" />
          </Link>
          <nav className="hidden md:flex gap-6">
            <Link to="/#servicos" className="text-muted-foreground hover:text-primary transition-colors">
              Serviços
            </Link>
            <Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors">
              Blog
            </Link>
            <Link to="/seguranca-digital" className="text-muted-foreground hover:text-primary transition-colors">
              Segurança Digital
            </Link>
            <Link to="/contato" className="text-muted-foreground hover:text-primary transition-colors">
              Contato
            </Link>
          </nav>
          <Button asChild variant="outline" className="border-primary/50 text-primary hover:bg-primary/10">
            <a href="https://folio.app.br/area-cliente">Área do Cliente</a>
          </Button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="py-20 px-4">
        <div className="container mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-foreground mb-6">
              Sobre a <span className="text-primary">Coddar</span>
            </h1>
            <p className="text-xl text-muted-foreground">
              Somos uma empresa especializada em desenvolvimento de software, automação de processos e consultoria em TI,
              comprometida em entregar soluções tecnológicas que transformam negócios.
            </p>
          </div>
        </div>
      </section>

      {/* Nossa História */}
      <section className="py-16 px-4 bg-card/30">
        <div className="container mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
                Nossa História
              </h2>
              <div className="space-y-4 text-muted-foreground">
                <p>
                  Fundada em 2019, a Coddar nasceu com o propósito de democratizar o acesso à tecnologia de ponta
                  para empresas de todos os tamanhos. Começamos como uma pequena equipe de desenvolvedores apaixonados
                  por criar soluções que realmente fazem a diferença.
                </p>
                <p>
                  Ao longo dos anos, expandimos nossos serviços e expertise, sempre mantendo nosso compromisso com a
                  qualidade e inovação. Hoje, atendemos clientes em diversos segmentos, desde startups até grandes
                  corporações, ajudando-os a alcançar seus objetivos através da tecnologia.
                </p>
                <p>
                  Nossa equipe é formada por profissionais experientes e certificados, que trabalham com as tecnologias
                  mais modernas do mercado, garantindo soluções robustas, escaláveis e seguras.
                </p>
              </div>
            </div>
            <div className="relative">
              <div className="aspect-square rounded-2xl bg-gradient-to-br from-primary/20 to-accent/20 flex items-center justify-center">
                <Users className="h-32 w-32 text-primary" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Missão, Visão e Valores */}
      <section className="py-20 px-4">
        <div className="container mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground text-center mb-12">
            Nossos Pilares
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <Card key={index} className="border-border/50 bg-card/50 backdrop-blur-sm">
                  <CardHeader>
                    <div className="h-14 w-14 rounded-xl bg-gradient-to-br from-primary/20 to-accent/20 flex items-center justify-center mb-4">
                      <Icon className="h-7 w-7 text-primary" />
                    </div>
                    <CardTitle className="text-xl">{value.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground">{value.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 px-4 bg-card/30">
        <div className="container mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-6">
            Pronto para transformar seu negócio?
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Entre em contato conosco e descubra como podemos ajudar sua empresa a alcançar novos patamares
          </p>
          <Button size="lg" asChild className="gap-2">
            <Link to="/contato">
              Fale Conosco <ArrowRight className="h-4 w-4" />
            </Link>
          </Button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Sobre;
